import { useStoreConfig } from '~/store/storeConfig'
import { useLanguageStore } from '~/store/language'

export default defineNuxtPlugin((_nuxtApp) => {
  const site = useStoreConfig().getSite

  const languageId = useLanguageStore().getLanguageId

  const currentLanguage = site?.languages?.find((predicate) => predicate.id === languageId)

  const googleTagManagerId = currentLanguage?.pivot.gtm_id || null

  if (googleTagManagerId) {
    useHead({
      script: [
        {
          src: `https://www.googletagmanager.com/gtm.js?id=GTM-${googleTagManagerId}`,
          defer: true,
        },
      ],
    })
  }
})
